import IMG_LOGO from 'assets/slickpay-splash/logoes/Slickpay.png';
import ExternalLink from 'components/generic/ExternalLink.component';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import { useTranslation } from 'providers/GILT.provider';

import CN from './SlickPayTopContainer.module.scss';

const SlickPayTopContainer = () => {
  const { t } = useTranslation();
  const { slickPayCardReaderHelpLink } = useHelpLinks();

  return (
    <section data-bem="SlickPayTopContainer" className={CN.topContainer}>
      <div className={CN.row}>
        <div data-bem="SlickPayTopContainer__logo" className={CN.logo}>
          <img src={IMG_LOGO} alt="Slick logo" />
        </div>
        <ExternalLink link={slickPayCardReaderHelpLink}>
          <div className={CN.question}>{t('slickPay.gotQuestions')}</div>
        </ExternalLink>
      </div>
      <div className={CN.row}>
        <div className={CN.title}>{t('slickPay.cardReader')}</div>
      </div>
    </section>
  );
};
export default SlickPayTopContainer;
